import { useDispatch } from "react-redux";
import Xarrow from "react-xarrows";
import { importFromYaml } from "../../../../abstract/controller/modelYamlImport";
import { useArrowSync } from "../../../../abstract/hook/useArrowSync";
import { setRoot } from "../../../../abstract/redux/slice/structureSlice";
import ButtonIntroWide from "../../../ui/buttons/ButtonIntroWide";
import ButtonTomatoClose from "../../../ui/buttons/ButtonTomatoClose";
import styles from "./Manual.module.scss";

const showMe = `
global parameters:
  - parameter: weapon
    choices:
      - choice: sword
        value: Excalibur
      - choice: dagger
      - choice: axe
      - choice: mace
      - choice: ranged
        choices:
          - choice: bow
          - choice: crossbow
functions:
  - function: simple
    parameters:
      - parameter: hero
        choices:
          - choice: Peter
          - choice: Susan
          - choice: Edmund
          - choice: Lucy
      - linked parameter: hero weapon
        linked to: weapon
      - parameter: foe
        choices:
          - choice: witch
          - choice: cyclops
          - choice: giant
      - linked parameter: foe weapon
        linked to: weapon
      - parameter: location
        choices:
          - choice: forest
          - choice: castle
          - choice: river
          - choice: mountain
          - choice: lake
    logic:
      - constraint: Edmund uses ranged weapons
        expression: "'hero' IS 'Edmund' => 'hero weapon' IS 'ranged'"

`;

const goBack = `
global parameters:
  - parameter: weapon
    choices:
      - choice: sword
      - choice: dagger
      - choice: axe
      - choice: mace
      - choice: ranged
        choices:
          - choice: bow
          - choice: crossbow
functions:
  - function: simple
    parameters:
      - parameter: hero
        choices:
          - choice: Peter
          - choice: Susan
          - choice: Edmund
          - choice: Lucy
      - linked parameter: hero weapon
        linked to: weapon
      - parameter: foe
        choices:
          - choice: witch
          - choice: cyclops
          - choice: giant
      - linked parameter: foe weapon
        linked to: weapon
      - parameter: location
        choices:
          - choice: forest
          - choice: castle
          - choice: river
          - choice: mountain
          - choice: lake
`;

function ManualHierarchyAndValues3({ setTutorial }) {
  const _dispatch = useDispatch();
  const renderTrigger = useArrowSync();

  const handleShowMe = () => {
    const { model } = importFromYaml(showMe);
    _dispatch(setRoot(model, 0));
  };

  const handleBack = () => {
    const { model } = importFromYaml(goBack);
    _dispatch(setRoot(model, 0));
    setTutorial("hav2");
  };

  const handleClose = () => {
    setTutorial("null");
  };

  return (
    <>
      {document.getElementById("header_logic") && !document.getElementById("logic_constraint") && (
        <div className={`${styles["container"]} ${styles["container-hv3a"]} ${styles["overlay"]}`}>
          <div id="tutorial-text-gp1a" className={`${styles["container__text"]}`}>
            <p>To show/hide logic click on the header.</p>
          </div>

          <Xarrow
            key={`arrow-1-${renderTrigger}`}
            start="tutorial-text-gp1a"
            end="header_logic"
            color="#415B32"
            strokeWidth={2}
            path="smooth"
            curveness={0.8}
            headSize={6}
          />
        </div>
      )}

      {document.getElementById("logic_constraint") && (
        <div className={`${styles["container"]} ${styles["container-hv3b"]} ${styles["overlay"]}`}>
          <div
            id="tutorial-text-gp1b"
            className={`${styles["container__text"]} ${styles["container__text"]}`}>
            <p>Click here to add a constraint</p>
          </div>

          <Xarrow
            key={`arrow-3-${renderTrigger}`}
            start="tutorial-text-gp1b"
            end="logic_constraint"
            color="#415B32"
            strokeWidth={2}
            path="smooth"
            curveness={0.8}
            headSize={6}
          />
        </div>
      )}

      <div className={`${styles["foreground"]} ${styles["foreground-hv3"]}  ${styles["overlay"]}`}>
        <ButtonTomatoClose onClick={handleClose} />
        <div className={styles["header"]}>
          <div className={styles["header__assistant"]}></div>
          <div className={styles["header__text--main"]}>
            <p>
              Using abstract choices is a handy way to simplify constraints. Now, let's create a
              constraint that encourages <b>Edmund</b> to use ranged weapons.
            </p>
            <p>
              To access logic of a function, click on the <b>FUNCTION LOGIC</b> tab, which is
              located at the bottom of the screen.
            </p>
            <p>
              To create a constraint, select the <b>Constraints</b> section. A button named{" "}
              <b>ADD CONSTRAINT</b> should appear. Type its name, which should be{" "}
              <b>Edmund uses ranged weapons</b>. Afterwards, type the expression, namely:{" "}
              <b>'hero' IS 'Edmund' =&gt; 'hero weapon' IS 'ranged'</b>.
            </p>
          </div>
        </div>
        <div className={styles["confirmation"]}>
          <div className={styles["button"]}>
            <ButtonIntroWide theme="red" title="Go back!" onClick={handleBack} />
          </div>
          <div className={styles["button"]}>
            <ButtonIntroWide theme="tomato" title="Show me!" onClick={handleShowMe} />
          </div>
        </div>
      </div>
    </>
  );
}

export default ManualHierarchyAndValues3;
